import { supabase } from "./supabase";

export interface ITaskService {
  checkIn(): Promise<void>;
  updateOnlineTime(isMatchMode?: boolean): Promise<void>;
  incrementInteraction(): Promise<void>;
  completeTask(): Promise<void>;
}

export const taskService: ITaskService = {
  checkIn: async () => {
    await supabase.rpc("increment_daily_online_minutes", {
      minutes_to_add: 0,
      is_match_mode: false,
    });
  },

  updateOnlineTime: async (isMatchMode: boolean = false) => {
    await supabase.rpc("increment_daily_online_minutes", {
      minutes_to_add: 1,
      is_match_mode: isMatchMode,
    });
  },

  incrementInteraction: async () => {},

  completeTask: async () => {
    await supabase.rpc("complete_daily_task");
  },
};
